import type { PropsWithChildren } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { FAST_DURATION, useReducedMotion } from '@/lib/motion-presets';
import { Spinner } from './ui/spinner';

/** Blur/spinner overlay for mutations (save/upload). Not for initial page fetch inside AnimatedPage — see main-panel.mdc. */
export default function LoadingWrapper({ children, show }: PropsWithChildren<{ show?: boolean }>) {
	const reducedMotion = useReducedMotion();

	if (reducedMotion) {
		if (!show) return children;
		return (
			<div className='relative'>
				<div className='blur-xs pointer-events-none select-none'>{children}</div>
				<Spinner className='absolute inset-0 mx-auto my-auto w-10 h-10' />
			</div>
		);
	}

	return (
		<div className='relative'>
			{children}
			<AnimatePresence>
				{show ? (
					<motion.div
						key='loading-overlay'
						className='absolute inset-0 z-10 pointer-events-auto'
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						transition={{ duration: FAST_DURATION }}
					>
						<div className='absolute inset-0 blur-xs pointer-events-none select-none bg-background/20' />
						<motion.div
							className='absolute inset-0 flex items-center justify-center'
							initial={{ opacity: 0, scale: 0.9 }}
							animate={{ opacity: 1, scale: 1 }}
							exit={{ opacity: 0, scale: 0.9 }}
							transition={{ duration: FAST_DURATION }}
						>
							<Spinner className='w-10 h-10' />
						</motion.div>
					</motion.div>
				) : null}
			</AnimatePresence>
		</div>
	);
}
